/* eslint-disable react-hooks/exhaustive-deps */
"use client";

import { useEffect, useRef, useState } from "react";
import { FaPause, FaPlay } from "react-icons/fa";

interface IVideoPlayerProps {
  src: string;
  className?: string;
  videoClassName?: string;
  thumbnail?: string
  controllerButton?: boolean
}

export const VideoPlayer = ({
  src,
  className = "",
  videoClassName = "",
  thumbnail = "",
  controllerButton = true
}: IVideoPlayerProps) => {
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const togglePlay = () => {
    if (!videoRef.current) return;

    if (isPlaying) {
      videoRef.current.pause();
      setIsPlaying(false);
    } else {
      videoRef.current.play().catch((error) => {
        console.warn("Autoplay blocked:", error);
      });
      setIsPlaying(true);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && videoRef.current) {
          videoRef.current
            .play()
            .then(() => setIsPlaying(true))
            .catch((error) => {
              console.warn("Autoplay blocked by browser:", error);
              setIsPlaying(false);
            });
        } else if (videoRef.current) {
          videoRef.current.pause();
          setIsPlaying(false);
        }
      },
      { threshold: 0.5 }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);

  return (
    <div className={`relative z-0 ${className}`}>
      <video
        ref={videoRef}
        src={src}
        className={`relative bg-white w-full rounded-md mix-blend-multiply object-cover ${videoClassName}`}
        loop
        muted
        playsInline
        poster={thumbnail ?? "/images/default_video.webp"}
      >
        Seu navegador não suporta o elemento de vídeo.
      </video>

      {controllerButton && <button
        onClick={togglePlay}
        aria-label={isPlaying ? "Stop video" : "Play vídeo"}
        className="absolute bottom-4 right-4 bg-white/[.5] text-primary/[.5] flex items-center justify-center w-10 h-10 rounded-full transition-transform transform hover:scale-105 focus:ring-4 focus:ring-transparent focus:outline-none"
      >
        {isPlaying ? <FaPause size={14} /> : <FaPlay size={14} />}
      </button>}
    </div>
  );
};
